import {
  ProjectAPIRawRequestBodyType,
  ProjectAPIRequestBodyType
} from '../../types/project/api-request-body';

export const ProjectAPIRequestBody = ({
  name,
  companyId
}: ProjectAPIRequestBodyType): ProjectAPIRawRequestBodyType => ({
  name,
  company_id: companyId
});

export const ProjectAPIRequestBodyPartial = ({
  name,
  companyId
}: Partial<
  ProjectAPIRequestBodyType
>): Partial<ProjectAPIRawRequestBodyType> => ({
  name,
  company_id: companyId
});
